import styled from '@emotion/styled';
import { designSystem } from './theme';

// �t� tD� ����
export const PageContainer = styled.div`
    /* App.tsx Container가 max-width 1260 + margin auto + 좌우 padding 보장 */
    /* 페이지 고유 세로 padding만 유지 */
    padding: ${designSystem.styles.spacing.md} 0;
    background: ${designSystem.colors.background.primary};
    min-height: 100vh;

    @media (max-width: 768px) {
        padding: ${designSystem.styles.spacing.sm} 0;
    }
`;

export const PageHeader = styled.div`
    margin-bottom: ${designSystem.styles.spacing.lg};

    @media (max-width: 768px) {
        margin-bottom: ${designSystem.styles.spacing.md};
    }
`;

export const PageTitle = styled.h1`
    font-size: ${designSystem.styles.typography.fontSize['2xl']};
    font-weight: ${designSystem.styles.typography.fontWeight.bold};
    color: ${designSystem.colors.text.primary};
    margin: 0 0 8px 0;

    @media (max-width: 768px) {
        font-size: ${designSystem.styles.typography.fontSize.xl};
    }
`;

export const PageSubtitle = styled.p`
    font-size: ${designSystem.styles.typography.fontSize.base};
    color: ${designSystem.colors.text.secondary};
    margin: 0;

    @media (max-width: 768px) {
        font-size: ${designSystem.styles.typography.fontSize.sm};
    }
`;

// ��� tD�
export const GridContainer = styled.div<{ columns?: string; gap?: string }>`
    display: grid;
    grid-template-columns: ${props => props.columns || '1fr 2fr'};
    gap: ${props => props.gap || designSystem.styles.spacing.md};
    margin-bottom: ${designSystem.styles.spacing.lg};

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
    }

    @media (max-width: 768px) {
        gap: ${props => props.gap || designSystem.styles.spacing.sm};
        margin-bottom: ${designSystem.styles.spacing.md};
    }
`;

export const MenuGrid = styled.div<{ minWidth?: string }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${props => props.minWidth || '280px'}, 1fr));
    gap: ${designSystem.styles.spacing.sm};
    margin-bottom: ${designSystem.styles.spacing.lg};

    @media (max-width: 768px) {
        gap: ${designSystem.styles.spacing.xs};
        margin-bottom: ${designSystem.styles.spacing.md};
    }
`;

// t� ����
export const Card = styled.div<{ padding?: string; hover?: boolean }>`
    background: ${designSystem.colors.background.white};
    border-radius: ${designSystem.styles.borderRadius.lg};
    padding: ${props => props.padding || designSystem.styles.spacing.lg};
    box-shadow: ${designSystem.colors.shadow.base};
    border: 1px solid ${designSystem.colors.border.light};
    transition: ${designSystem.styles.transitions.base};

    ${props => props.hover && `
        &:hover {
            box-shadow: ${designSystem.colors.shadow.md};
            transform: translateY(-2px);
        }
    `}

    @media (max-width: 768px) {
        padding: ${props => props.padding || designSystem.styles.spacing.md};
    }
`;

export const GradientCard = styled(Card)<{ hover?: boolean }>`
    background: ${designSystem.colors.gradient.primary};
    color: ${designSystem.colors.text.white};
    box-shadow: ${designSystem.colors.shadow.lg};
    border: none;
    
    ${props => props.hover && `
        &:hover {
            transform: translateY(-4px);
            background: ${designSystem.colors.gradient.primaryHover};
        }
    `}
`;

export const MenuItem = styled.div<{ padding?: string }>`
    background: ${designSystem.colors.background.white};
    border-radius: ${designSystem.styles.borderRadius.md};
    padding: ${props => props.padding || designSystem.styles.spacing.md};
    text-align: center;
    cursor: pointer;
    border: 1px solid ${designSystem.colors.border.light};
    transition: ${designSystem.styles.transitions.base};

    &:hover {
        box-shadow: ${designSystem.colors.shadow.md};
        transform: translateY(-4px);
        border-color: ${designSystem.colors.primary};
    }

    svg {
        font-size: 3rem;
        color: ${designSystem.colors.primary};
        margin-bottom: ${designSystem.styles.spacing.sm};
    }

    span {
        font-size: ${designSystem.styles.typography.fontSize.base};
        font-weight: ${designSystem.styles.typography.fontWeight.semibold};
        color: ${designSystem.colors.text.primary};
    }

    @media (max-width: 768px) {
        padding: ${props => props.padding || designSystem.styles.spacing.sm};

        svg {
            font-size: 2rem;
            margin-bottom: ${designSystem.styles.spacing.xs};
        }

        span {
            font-size: ${designSystem.styles.typography.fontSize.sm};
        }
    }
`;

// 9X ����
export const SectionCard = styled(Card)`
    margin-bottom: ${designSystem.styles.spacing.md};

    &:hover {
        box-shadow: ${designSystem.colors.shadow.md};
    }

    @media (max-width: 768px) {
        margin-bottom: ${designSystem.styles.spacing.sm};
    }
`;

export const SectionTitle = styled.h2<{ color?: string }>`
    font-size: ${designSystem.styles.typography.fontSize.xl};
    font-weight: ${designSystem.styles.typography.fontWeight.bold};
    color: ${props => props.color || designSystem.colors.text.primary};
    margin: 0 0 ${designSystem.styles.spacing.md} 0;
    display: flex;
    align-items: center;
    gap: 12px;

    &::before {
        content: '';
        width: 4px;
        height: 24px;
        background: ${designSystem.colors.gradient.primary};
        border-radius: 2px;
    }

    @media (max-width: 768px) {
        font-size: ${designSystem.styles.typography.fontSize.lg};
        margin: 0 0 ${designSystem.styles.spacing.sm} 0;
        gap: 8px;

        &::before {
            width: 3px;
            height: 18px;
        }
    }
`;

// �� ����
export const PrimaryButton = styled.button<{ size?: 'sm' | 'md' | 'lg' }>`
    background: ${designSystem.colors.gradient.primary};
    color: ${designSystem.colors.text.white};
    border: none;
    border-radius: ${designSystem.styles.borderRadius.sm};
    padding: ${props => {
        switch (props.size) {
            case 'sm': return '8px 16px';
            case 'lg': return '16px 32px';
            default: return '12px 24px';
        }
    }};
    cursor: pointer;
    font-weight: ${designSystem.styles.typography.fontWeight.medium};
    transition: ${designSystem.styles.transitions.base};
    font-size: ${designSystem.styles.typography.fontSize.base};
    
    &:hover {
        background: ${designSystem.colors.gradient.primaryHover};
        transform: translateY(-1px);
        box-shadow: ${designSystem.colors.shadow.md};
    }
    
    &:disabled {
        background: ${designSystem.colors.border.medium};
        cursor: not-allowed;
        transform: none;
    }
`;

export const SecondaryButton = styled.button<{ size?: 'sm' | 'md' | 'lg' }>`
    background: ${designSystem.colors.background.white};
    color: ${designSystem.colors.text.secondary};
    border: 1px solid ${designSystem.colors.border.light};
    border-radius: ${designSystem.styles.borderRadius.sm};
    padding: ${props => {
        switch (props.size) {
            case 'sm': return '8px 16px';
            case 'lg': return '16px 32px';
            default: return '12px 24px';
        }
    }};
    cursor: pointer;
    font-weight: ${designSystem.styles.typography.fontWeight.medium};
    transition: ${designSystem.styles.transitions.base};
    font-size: ${designSystem.styles.typography.fontSize.base};
    
    &:hover {
        background: ${designSystem.colors.background.light};
        border-color: ${designSystem.colors.border.dark};
        transform: translateY(-1px);
    }
    
    &:disabled {
        background: ${designSystem.colors.background.light};
        cursor: not-allowed;
        transform: none;
    }
`;

// �� ��
export const ButtonGroup = styled.div<{ gap?: string; justify?: string }>`
    display: flex;
    gap: ${props => props.gap || designSystem.styles.spacing.sm};
    justify-content: ${props => props.justify || 'center'};
    margin-top: ${designSystem.styles.spacing.xl};
    padding: ${designSystem.styles.spacing.sm} 0;
`;

// M�� ����
export const Title = styled.h1<{ size?: string; color?: string }>`
    font-size: ${props => props.size || designSystem.styles.typography.fontSize.xl};
    font-weight: ${designSystem.styles.typography.fontWeight.bold};
    color: ${props => props.color || designSystem.colors.text.primary};
    margin: 0;
`;

export const Subtitle = styled.h2<{ size?: string; color?: string }>`
    font-size: ${props => props.size || designSystem.styles.typography.fontSize.lg};
    font-weight: ${designSystem.styles.typography.fontWeight.semibold};
    color: ${props => props.color || designSystem.colors.text.primary};
    margin: 0;
`;

export const Text = styled.p<{ size?: string; color?: string; weight?: string }>`
    font-size: ${props => props.size || designSystem.styles.typography.fontSize.base};
    font-weight: ${props => props.weight || designSystem.styles.typography.fontWeight.normal};
    color: ${props => props.color || designSystem.colors.text.primary};
    margin: 0;
    line-height: 1.6;
`;

// \)  �� ����
export const LoadingMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
    font-size: ${designSystem.styles.typography.fontSize.base};
    color: ${designSystem.colors.text.secondary};
`;

export const ErrorMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
    font-size: ${designSystem.styles.typography.fontSize.base};
    color: ${designSystem.colors.status.error};
`;

// ��� ����
export const ListItem = styled.div<{ padding?: string; border?: boolean }>`
    background: ${designSystem.colors.background.white};
    border-radius: ${designSystem.styles.borderRadius.sm};
    padding: ${props => props.padding || designSystem.styles.spacing.sm};
    margin-bottom: ${designSystem.styles.spacing.xs};
    ${props => props.border && `border: 1px solid ${designSystem.colors.border.light};`}
    transition: ${designSystem.styles.transitions.fast};
    
    &:hover {
        background: ${designSystem.colors.background.light};
    }
`;